import { DEFAULT_ACCOUNT_MANAGER } from '@/lib/repository/constants';

export const BENEDIKT_EMAIL = 'b.ruf@gindumac.com';

export const accountManagers = [
  DEFAULT_ACCOUNT_MANAGER,
  {
    name: 'Oliver Maxeiner',
    email: 'o.maxeiner@gindumac.com',
    profile_picture:
      'https://gindumac.s3.eu-central-1.amazonaws.com/staff/profile_pictures/oliver.png',
    phone: '+49 174 2629 614',
    locales: [],
  },
  {
    name: 'Aigar Vaskans',
    email: 'a.vaskans@gindumac.com',
    profile_picture:
      'https://gindumac.s3.eu-central-1.amazonaws.com/staff/profile_pictures/aigar_vaskans.jpg',
    phone: '+371 24 848 548',
    locales: [],
  },
  {
    name: 'Manuel Gricar',
    email: 'm.gricar@gindumac.com',
    profile_picture:
      'https://gindumac.s3.eu-central-1.amazonaws.com/staff/profile_pictures/staff_default.jpg',
    phone: '+386 30 339 402',
    locales: [],
  },
  {
    name: 'Benedikt Ruf',
    email: BENEDIKT_EMAIL,
    profile_picture:
      'https://s3.eu-central-1.amazonaws.com/gindumac/staff/profile_pictures/benedikt-ruf.png',
    phone: '+49 173 273 19 73',
    locales: [],
  },
  {
    name: 'Philipp Gubisch',
    email: 'p.gubisch@gindumac.com',
    profile_picture:
      'https://s3.eu-central-1.amazonaws.com/gindumac/staff/profile_pictures/philipp_gubisch.jpg',
    phone: '+49 162 402 75 81',
    locales: ['de-AT', 'de-DE'],
  },
  {
    name: 'Petr Strýček',
    email: 'p.strycek@gindumac.com',
    profile_picture:
      'https://gindumac.s3.eu-central-1.amazonaws.com/staff/profile_pictures/Petr_Strycek_black_and_white.png',
    phone: '+420 737 021 218',
    locales: ['cs-CZ'],
  },
  {
    name: 'Alessandro Martini',
    email: 'a.martini@gindumac.com',
    profile_picture:
      'https://s3.eu-central-1.amazonaws.com/gindumac/staff/profile_pictures/Alessandro_Martini.jpg',
    phone: '+49 162 585 84 48',
    locales: [],
  },
  {
    name: 'Ahmed Mody',
    email: 'a.mody@gindumac.com',
    profile_picture:
      'https://s3.eu-central-1.amazonaws.com/gindumac/staff/profile_pictures/ahmed_mody.png',
    phone: '+49 172 465 20 64',
    locales: [],
  },
  {
    name: 'Максим Озерин',
    email: 'm.ozerin@gindumac.com',
    profile_picture:
      'https://s3.eu-central-1.amazonaws.com/gindumac/staff/profile_pictures/Maxim_Ozerin.png',
    phone: '+7 937 070 8431',
    locales: ['ru-RU'],
  },
  {
    name: 'Tapio Kautto',
    email: 't.kautto@gindumac.com',
    profile_picture:
      'https://s3.eu-central-1.amazonaws.com/gindumac/staff/profile_pictures/tapio.png',
    phone: '+358 44 088 8600',
    locales: [],
  },
  {
    name: 'Istvan Fazekas',
    email: 'i.fazekas@gindumac.com',
    profile_picture:
      'https://s3.eu-central-1.amazonaws.com/gindumac/staff/profile_pictures/Istvan_Fazekas.png',
    phone: '+36 30 997 0294',
    locales: [],
  },
  {
    name: 'Pankaj Patel',
    email: 'p.patel@gindumac.com',
    profile_picture:
      'https://s3.eu-central-1.amazonaws.com/gindumac/staff/profile_pictures/pankaj_patel.jpg',
    phone: '+49 631 680 39 300',
    locales: [],
  },
  {
    name: 'Noel Moloney',
    email: 'n.moloney@gindumac.com',
    profile_picture:
      'https://gindumac.s3.eu-central-1.amazonaws.com/staff/profile_pictures/noel.jpg',
    phone: '+353 838 108 745',
    locales: [],
  },
  {
    name: 'Jacek Chwist',
    email: 'j.chwist@gindumac.com',
    profile_picture:
      'https://gindumac.s3.eu-central-1.amazonaws.com/staff/profile_pictures/jacek-chwist.png',
    phone: '+48 502 956 980',
    locales: [],
  },
  {
    name: 'Mauri Kautto',
    email: 'm.kautto@gindumac.com',
    profile_picture:
      'https://s3.eu-central-1.amazonaws.com/gindumac/staff/profile_pictures/mauri_kautto.png',
    phone: '+358 44 4100 145',
    locales: [],
  },
  {
    name: 'David Amigo Lardies',
    email: 'd.amigo@gindumac.com',
    profile_picture:
      'https://gindumac.s3.eu-central-1.amazonaws.com/staff/profile_pictures/david_amigo.jpg',
    phone: '+34 689 85 46 96',
    locales: [],
  },
  {
    name: 'Stan Reijrink',
    email: 's.reijrink@gindumac.com',
    profile_picture:
      'https://gindumac.s3.eu-central-1.amazonaws.com/staff/profile_pictures/Stan_Reijrink.jpg',
    phone: '+31 6 29563297',
    locales: [],
  },
  {
    name: 'Chloé Martin',
    email: 'c.martin@gindumac.com',
    profile_picture:
      'https://gindumac.s3.eu-central-1.amazonaws.com/staff/profile_pictures/Chloe_Martin.jpg',
    phone: '+33 7 86 98 48 01',
    locales: ['fr-FR'],
  },
  {
    name: 'José María García',
    email: 'j.garcia@gindumac.com',
    profile_picture:
      'https://s3.eu-central-1.amazonaws.com/gindumac/staff/profile_pictures/JM.jpg',
    phone: '+34 601 158 008',
    locales: ['es-ES', 'es-MX', 'pt-PT'],
  },
];
